// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"49301a1a","342":"663d25a8","430":"8dbc6a8f","464":"7316469c","587":"42a1c994","872":"d2fc03a7"}[chunkId] + ".chunk.js";
};